export default __webpack_public_path__ + "static/media/paypal.d05923c8.svg";